import { useQuery } from '@tanstack/react-query';
import siteContentService, {
  type FounderImages,
} from '@/services/siteContentService';

/**
 * Clave de la query. La comparte el panel admin para invalidarla al guardar,
 * así el cambio se refleja sin recargar (RF-2).
 */
export const FOUNDER_IMAGES_QUERY_KEY = ['founder-images'];

/**
 * Imágenes de la fundadora vigentes. Devuelve `undefined` mientras carga o si
 * la API no responde: la sección cae entonces a la imagen por defecto (RF-4).
 */
export const useFounderImages = (): FounderImages | undefined => {
  const { data } = useQuery({
    queryKey: FOUNDER_IMAGES_QUERY_KEY,
    queryFn: () => siteContentService.getFounderImages(),
    staleTime: 5 * 60 * 1000,
  });

  return data;
};
